import { render, staticRenderFns } from "./ThemeSwitcher.vue?vue&type=template&id=46e94ea1&scoped=true"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=ts"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./ThemeSwitcher.vue?vue&type=style&index=0&id=46e94ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e94ea1",
  null
  
)

export default component.exports